import * as React from "react";
import { Grid, Typography, Chip } from "@mui/material";
import { colors } from "../../../styles/colors";

interface SalaryDetailsProps {
  job: any;
}

const SalaryDetails = (props: SalaryDetailsProps) => {
  const { job } = props;

  // Helper function to convert perks object to display array
  const formatPerks = (perks?: { [key: string]: boolean } | string[]): string[] => {
    if (!perks) return [];
    
    // If it's already an array, return as is
    if (Array.isArray(perks)) return perks;
    
    // Convert object format to display array
    const perkLabels: { [key: string]: string } = {
      freeLunch: 'Free Lunch',
      transport: 'Transportation',
      freeSnacks: 'Free Snacks',
      fiveDayWork: '5-Day Work Week',
      others: 'Other Benefits'
    };
    
    const activePerksList: string[] = [];
    
    // Check each perk and add to list if true
    Object.entries(perks).forEach(([key, value]) => {
      if (value === true && perkLabels[key]) {
        activePerksList.push(perkLabels[key]);
      }
    });
    
    return activePerksList;
  };

  // console.log({ perks });

  return (
    <Grid container spacing={1} sx={{ my: 3 }}>
      <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mb: 1 }}>
        <Typography fontSize="16px" fontWeight={500}>
          Salary Details
        </Typography>
      </Grid>
      <Grid item lg={3} md={3} sm={3} xs={12}>
        <Typography fontSize="14px" color={colors.lightGrey}>
          Salary Amount
        </Typography>
        {props?.job?.job?.salary_confidential ? (
          <Typography color={colors.primaryBlue} fontSize="15px" mt={1}>
            ****
          </Typography>
        ) : props?.job?.job?.stipend_type === "fixed" ? (
          <Typography color={colors.primaryBlue} fontSize="15px" mt={1}>
            ₹{" "}
            {props?.job?.job?.minimum_remuneration
              ? props?.job?.job?.minimum_remuneration
              : "*"}
          </Typography>
        ) : props?.job?.job?.stipend_type === "noStipend" ? (
          <Typography color={colors.fontLight} fontSize="15px" mt={1}>
            No Stipend
          </Typography>
        ) : (
          <Typography color={colors.primaryBlue} fontSize="15px" mt={1}>
            ₹{" "}
            {props?.job?.job?.minimum_remuneration
              ? props?.job?.job?.minimum_remuneration
              : "*"}{" "}
            to ₹{" "}
            {props?.job?.job?.maximum_remuneration
              ? props?.job?.job?.maximum_remuneration
              : "*"}
          </Typography>
        )}
      </Grid>
      <Grid item container lg={9} md={9} sm={9} xs={12}>
        <Grid item lg={12} md={12} sm={12} xs={12} mb={1}>
          <Typography fontSize="14px" color={colors.lightGrey}>
            Perks
          </Typography>
        </Grid>
        <Grid item container spacing={2} lg={12} md={12} sm={12} xs={12} mb={1}>
          {(() => {
            const formattedPerks = formatPerks(props?.job?.job?.perks);
            return formattedPerks.length > 0 ? (
              formattedPerks.map((perk, index) => (
                <Grid key={index} item>
                  <Chip
                    label={perk}
                    sx={{
                      backgroundColor: colors.lightBlueChip,
                      color: colors.primaryBlue,
                      borderRadius: "2px"
                    }}
                  />
                </Grid>
              ))
            ) : (
              <Grid item>
                <Typography>-</Typography>
              </Grid>
            );
          })()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SalaryDetails;
